import { Footer } from '../../Components/Footer/FooterComponent';
import { LogoHeader } from '../../Components/Inicio/LogoHeaderComponent';
import { NavDesktop } from '../../Components/Inicio/NavDesktop';
import { NavMobile } from '../../Components/Inicio/NavMobile';
import { NotificacionesComponent } from '../../Components/Notificaciones/NotificacionesComponent';

export const Notificaciones = (props) => {
    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <NotificacionesComponent I18n={props.I18n} user={props.User} />
            <Footer I18n={props.I18n} />
        </>
    )
}